import {MasterState} from '@target-web/leadads-form-view';
import {useCallback, useEffect, useMemo, useState} from 'react';
import {fetchComments} from 'utils/requests';
import {useSearchParams} from 'utils/searchParamsContext';

type useFilialInfoProps = {
    active: boolean;
};

export const useFilialInfo = ({active}: useFilialInfoProps) => {
    const [comments, setComments] = useState<MasterState['comments']>([]);
    const [isLoading, setIsLoading] = useState(true);

    const {formDataHash} = useSearchParams();

    const searchParams = useMemo(() => {
        const add_params: Record<string, string> = {lead_form_data: formDataHash};

        add_params.staff_id = '-1'; // только отзывы о филиале
        add_params.count = '50';

        return new URLSearchParams([...Object.entries(add_params)]);
    }, [formDataHash]);

    const getComments = useCallback(async () => {
        setIsLoading(true);
        const data = await fetchComments(searchParams.toString());
        setComments(data);
        setIsLoading(false);
    }, [searchParams]);

    useEffect(() => {
        if (active && !comments.length) {
            getComments();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getComments, active]);

    return {
        comments,
        isLoading,
    };
};
